<template>
  <div v-if="isReadyToDraw" class="ticket-romancecar">
    <MFITTHeader
      header-title="座席選択"
      :click-back-button-event="backToBooking3Page"
    />

    <!-- 入力した日付、区間、人数を表示 -->
    <MFITTTicketInfo
      :selected-train-info="selectedTrainInfo"
      :is-saloon="inputtedInfoOnBooking.special_designation.id == 8"
    />

    <div class="form">
      <!-- 一般席は号車選択 -->
      <MFITTBookingSelectBlockCarNumber
        v-if="inputtedInfoOnBooking.special_designation.id == 0"
        v-model:selectedCar="selectedCar"
        v-model:selectedSeat="selectedSeat"
        :open-conrifm-dialog="openConrifmResetSeatDialog"
        :cars="selectedTrainInfo.cars_formation.cars"
      />

      <div class="title-block">座席選択</div>

      <div
        v-if="inputtedInfoOnBooking.special_designation.id == 8"
        class="text-block"
      >
        ご希望のボックスを選択してください
      </div>
      <div v-else class="text-block">ご希望の座席を選択してください</div>

      <div class="direction-block clearfix">
        <!-- 藤沢~片瀬江ノ島間のみcarNumberVacancyStatus.destination.is_forward==false となるので"方面と進行方向"が逆になる -->
        <strong v-if="carNumberVacancyStatus.destination.is_forward">{{
          carNumberVacancyStatus.destination.to_station_name
        }}</strong>
        <strong v-else>{{
          carNumberVacancyStatus.destination.from_station_name
        }}</strong>
        方面
        <span
          v-if="carNumberVacancyStatus.destination.is_forward"
          class="float-text"
          >↑進行方向</span
        >
      </div>

      <!-- {{carNumberVacancyStatus.car}}<br><br>
        {{carNumberVacancyStatus.seats}}<br><br>-->
      <!-- {{selectedSeat}}  -->

      <!-- サルーンのシートマップ -->
      <MFITTSeatMapSaloon
        v-if="inputtedInfoOnBooking.special_designation.id == 8"
        v-model:selectedSeat="selectedSeat"
        :car-number="Number(selectedCar.number)"
        :car-number-vacancy-status="carNumberVacancyStatus"
        :inputted-info-on-booking="inputtedInfoOnBooking"
        @checkSeatsCount="checkSeatsCount"
      />

      <!-- 一般席・前/後展望席 -->
      <MFITTSeatMap
        v-else
        v-model:selectedSeat="selectedSeat"
        :special-designation="inputtedInfoOnBooking.special_designation.id"
        :car-number="Number(selectedCar.number)"
        :car-number-vacancy-status="carNumberVacancyStatus"
        :inputted-info-on-booking="inputtedInfoOnBooking"
        :selected-train-info="selectedTrainInfo"
        @checkSeatsCount="checkSeatsCount"
      />

      <div class="direction-block">
        <!-- 藤沢~片瀬江ノ島間のみcarNumberVacancyStatus.destination.is_forward==false となるので"方面と進行方向"が逆になる -->
        <strong v-if="carNumberVacancyStatus.destination.is_forward">{{
          carNumberVacancyStatus.destination.from_station_name
        }}</strong>
        <strong v-else>{{
          carNumberVacancyStatus.destination.to_station_name
        }}</strong>
        方面
        <span
          v-if="!carNumberVacancyStatus.destination.is_forward"
          class="float-text"
          >↓進行方向</span
        >
      </div>

      <div class="text-block">
        <img
          :src="require(`@/assets/img/icon/svg/i-seat-common.svg`)"
          class="icon"
        /><span>一般席</span>
        <img
          :src="require(`@/assets/img/icon/svg/i-seat-wc.svg`)"
          class="icon"
        /><span>車いす席</span>
        <img
          :src="require(`@/assets/img/icon/svg/i-seat-care.svg`)"
          class="icon"
        />介護席<br />
        <p>シートマップは複数号車での座席指定はできません</p>
        <br />
        <span v-if="carNumberVacancyStatus.car.boarding_gate_position == null"
          >乗降口は隣の号車にあります</span
        ><br />
        <span class="window" /> は窓枠の位置です<br />
        <span v-html="makeRestroomCarNumbers()" />
      </div>

      <div class="actions">
        <ItemButton
          action-type="btn-primary"
          label="次へ"
          :disabled="!isValidSeatCount"
          @clicked="onClickNext"
        />
      </div>
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeout-seconds="21000" />

  <!-- 購入期限を超えて座席指定しようとした場合のエラーダイアログ -->
  <DialogCanNotGoToSheetMapByPurchaseLimit
    ref="DialogCanNotGoToSheetMapByPurchaseLimit"
    :close-button-clicked="backToBooking3Page"
  />

  <!-- 予約期限を超えて座席指定しようとした場合のエラーダイアログ -->
  <DialogCanNotReserveBecauseOverLimit
    ref="DialogCanNotReserveBecauseOverLimit"
    :close-button-clicked="backToBooking3Page"
  />

  <!-- 選択中の座席がある場合に、号車を変更する際の確認ダイアログ　-->
  <DialogConfirmResetSelectedSeat
    ref="DialogConfirmResetSelectedSeat"
    :click-ok="resetSelectedSeatAndChangeCar"
  />

  <DialogConfirmSelectedSpecialSeat
    ref="DialogConfirmSelectedSpecialSeat"
    :click-ok="goToNextPage"
  />

  <DialogConfirmSelectedSpecialCar
    ref="DialogConfirmSelectedSpecialCar"
    :special-designation-id="inputtedInfoOnBooking.special_designation.id"
    :selected-car="selectedCar"
    :click-ok="goToNextPage"
  />

  <DialogNotExistSeat ref="DialogNotExistSeat" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception ref="DialogBadReception" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" />

  <DialogUnexpectedError ref="DialogUnexpectedError" />
</template>

<script>
import { onMounted, computed, watch, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useVModel } from "vue-composable";

import API from "@/API";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittBooking4",
  props: {
    selectedCar: {
      type: Object,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogLoading = ref(null);
    const DialogCanNotGoToSheetMapByPurchaseLimit = ref(null);
    const DialogCanNotReserveBecauseOverLimit = ref(null);
    const DialogConfirmResetSelectedSeat = ref(null);
    const DialogConfirmSelectedSpecialSeat = ref(null);
    const DialogConfirmSelectedSpecialCar = ref(null);
    const DialogNotExistSeat = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);

    const isReadyToDraw = ref(false);

    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    const isSubscription = selectedCoupon?.type == "subscription";
    const isExchange = selectedCoupon?.type == "exchange";

    // 選ばれた列車情報
    const selectedTrainInfo = computed(
      () => store.getters["MFITT/vacancyInquiry"].train_info[route.params.id]
    );

    // フロントで管理してる情報
    const inputtedInfoOnBooking = computed(
      () => store.getters["MFITT/inputtedInfoOnBooking"]
    );

    // 選ばれた号車
    const selectedCar = useVModel(props, "selectedCar");

    // 選ばれた席の配列を保持
    let selectedSeat = ref([]);

    // 号車の座席情報を保持する
    const carNumberVacancyStatus = computed(
      () => store.getters["MFITT/carNumberVacancyStatus"]
    );

    // 子コンポーネントで次へを押してもいいだけのシート選択がされたかのフラグ
    let isValidSeatCount = ref(false);

    // 子コンポーネントからフラグがEmitされてくる
    const checkSeatsCount = (flag) => {
      isValidSeatCount.value = flag;
    };

    // 号車をまたいだ座席選択は不可のため、号車切り替え時に選択中の座席をリセットする
    const resetSelectedSeatAndChangeCar = (selectCar) => {
      selectedSeat.value = [];
      isValidSeatCount.value = false;
      selectedCar.value = selectCar;
    };

    const openConrifmResetSeatDialog = (selectCar) => {
      DialogConfirmResetSelectedSeat.value.openDialog(selectCar);
    };

    const onClickNext = () => {
      if (mfittService.checkHasSelectedSpecialSeat(selectedSeat.value)) {
        DialogConfirmSelectedSpecialSeat.value.openDialog();
      } else if (selectedCar.value.is_exclusive) {
        DialogConfirmSelectedSpecialCar.value.openDialog();
      } else {
        goToNextPage();
      }
    };

    // 次へボタンで起こす処理
    const goToNextPage = () => {
      // フロントで管理すべき値を格納
      setInputtedInfo();

      if (
        inputtedInfoOnBooking.value.is_reservated ||
        inputtedInfoOnBooking.value.isPurchasedChange ||
        isSubscription ||
        isExchange
      ) {
        // 確認画面へ
        goToBookingConfirmation();
      } else {
        goToSelectPaymentMethod();
      }
    };

    // 確認画面へ
    const goToBookingConfirmation = () => {
      router.push({
        name: "MfittBookingConfirmation",
        params: { id: route.params.id },
        query: {
          coupon_id: route.query.coupon_id,
          changing_limited_express_ticket_id:
            route.query.changing_limited_express_ticket_id,
        },
      });
    };

    const goToSelectPaymentMethod = () => {
      router.push({
        name: "MfittSelectPaymentMethod",
        params: { id: route.params.id },
        query: {
          coupon_id: route.query.coupon_id,
          changing_limited_express_ticket_id:
            route.query.changing_limited_express_ticket_id,
        },
      });
    };

    // header/DialogのbackButton用の処理。
    // 条件に合う座席がないエラーで画面遷移してきた場合等にうまく動作しないので、明示的にbooking3を指定して戻る
    const backToBooking3Page = () => {
      router.push({
        name: "MfittBooking3",
        params: { id: route.params.id },
        query: {
          coupon_id: route.query.coupon_id,
          changing_limited_express_ticket_id:
            route.query.changing_limited_express_ticket_id,
        },
      });
    };

    // フロントで管理すべき値を格納
    const setInputtedInfo = () => {
      let addInfo = {
        car_id: selectedCar.value.id,
        car_number: selectedCar.value.number,
        selected_seats: selectedSeat.value,
      };

      console.log("addInfo :>> ", addInfo);
      store.commit("MFITT/setInputtedInfoOnBooking", {
        ...inputtedInfoOnBooking.value,
        ...addInfo,
      });
    };

    // 化粧室がどこにあるかを記載したStringを返す
    const makeRestroomCarNumbers = () => {
      let array = [];
      console.log(
        "makeRestroomCarNumbers selectedTrainInfo.value.cars_formation.cars :>> ",
        selectedTrainInfo.value.cars_formation.cars
      );
      selectedTrainInfo.value.cars_formation.cars.map((car) => {
        if (car.includes_restroom) {
          console.log("トイレあり！", car.number);
          array.push(car.number);
        }
      });
      return array.length > 0
        ? `化粧室は${array.join("、")}号車にあります`
        : "";
    };

    const resetSelectedCar = () => {
      selectedCar.value = selectedTrainInfo.value.cars_formation.cars[0];
    };

    // 号車の変更を感知して、APIを叩く
    watch(
      () => selectedCar.value,
      async (selectedCar) => {
        console.log("selectedCar :>> ", selectedCar);
        try {
          DialogLoading.value.openDialog();
          await API.getCarNumberVacancyStatus(
            selectedTrainInfo.value,
            selectedCar.id
          );
          DialogLoading.value.closeDialog();
        } catch (e) {
          // 電波がない場合、e.response.data.messageが存在しない
          // loadingを表示し続け、そちらでタイムアウトさせる
          if (e.response.data.message) {
            // 座席のない号車を選んでエラーになる場合があるので、選択号車を先頭に戻す
            resetSelectedCar();
            DialogLoading.value.closeDialog();
            // 予約期限(発車45分前)を過ぎている場合
            if (
              e.response.data.message ===
              "departure_at号車空席照会は発車時刻の45分前まで可能です"
            ) {
              DialogCanNotReserveBecauseOverLimit.value.openDialog();
              // 購入期限(発車3分前)を過ぎている場合
            } else if (
              e.response.data.message ===
              "departure_at号車空席照会は発車時刻の3分前まで可能です"
            ) {
              DialogCanNotGoToSheetMapByPurchaseLimit.value.openDialog();
              // 選択した号車に選択できる座席がない場合
            } else if (e.response.data.message === "座席が存在しません") {
              DialogNotExistSeat.value.openDialog(selectedCar.number);
            } else if (e.response.data.message === "回線が込み合っています") {
              DialogBadReception.value.openDialog();
              // MWのメンテナンス中
            } else if (e.response.status == 503) {
              DialogDuringMaintenance.value.openDialog(e.response.data);
            } else {
              // nativeにエラー内容送信
              nativeHandlerService.ncSendMfittError(e.response.data.message);
              DialogUnexpectedError.value.openDialog();
            }
          } else {
            nativeHandlerService.ncSendMfittError(
              "TemplateMfittBooking4 watch()"
            );
          }
        }
      }
    );

    // Mountedで号車情報APIが叩かれてレスポンスが帰ってきたら描画開始
    watchEffect(() => {
      if (carNumberVacancyStatus.value != null) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
      selectedTrainInfo,
      selectedCar,
      inputtedInfoOnBooking,
      carNumberVacancyStatus,
      selectedSeat,
      resetSelectedSeatAndChangeCar,
      goToNextPage,
      onClickNext,
      backToBooking3Page,
      isValidSeatCount,
      checkSeatsCount,
      DialogLoading,
      DialogBadReception,
      DialogCanNotGoToSheetMapByPurchaseLimit,
      DialogCanNotReserveBecauseOverLimit,
      DialogConfirmResetSelectedSeat,
      DialogConfirmSelectedSpecialSeat,
      DialogConfirmSelectedSpecialCar,
      DialogNotExistSeat,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      makeRestroomCarNumbers,
      openConrifmResetSeatDialog,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.form {
  margin: 20px 15px;
}

.text-block,
.direction-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
}

.text-block img.icon {
  width: 24px;
  height: auto;
  margin-right: 4px;
  vertical-align: bottom;
}

.text-block span {
  padding-right: 1em;
}

.text-block p {
  margin-top: 1em;
}

.direction-block {
  font-weight: normal;
}

.direction-block strong {
  font-weight: bold;
  text-decoration: none;
  font-size: 15px;
  padding-right: 3px;
}

.float-text {
  float: right;
}

.window {
  position: relative;
  border-right: 6px solid #bfa482;
  margin-right: 5px;
}
</style>
